import Memoize from "common/decorators/memoize";
import HttpService from "common/http/httpService";
import StateProvince from "domain/stateProvince";


class GeoService extends HttpService {
    @Memoize()
	async listStateProvinces(): Promise<StateProvince[]> {
		const response = await this.getClient().get<StateProvince[]>('/settings/v1/geo/states');
		return response.data;
	}
}

const geoService = new GeoService();
export default geoService;
